import { serviceOffers } from '@/data/pricing'

export const services = [
  { value: '', label: 'Select a service' },
  ...Object.values(serviceOffers).map((offer) => ({
    value: offer.id,
    label: `${offer.title} — ${offer.price}`,
  })),
  { value: 'herbal-consultation', label: 'Herbal Consultation' },
  { value: 'womens-health', label: "Women's Health Consultation" },
  { value: 'course-workshop', label: 'Course / Workshop Enquiry' },
  { value: 'product', label: 'Product Enquiry' },
  { value: 'speaking', label: 'Public Speaking / Programme' },
  { value: 'general', label: 'General Enquiry' },
]

export const contactTimes = [
  { value: '', label: 'No preference' },
  { value: 'morning', label: 'Morning (9am – 12pm)' },
  { value: 'afternoon', label: 'Afternoon (12pm – 5pm)' },
  { value: 'evening', label: 'Evening (5pm – 7pm)' },
]

export const process = [
  {
    n: '01',
    title: 'Submit Your Enquiry',
    desc: 'Fill in the form with your details and a brief overview of your health concerns or question.',
  },
  {
    n: '02',
    title: 'Kandake Reviews',
    desc: 'Kandake personally reads every enquiry and will respond within 24–48 hours.',
  },
  {
    n: '03',
    title: 'She Calls You Back',
    desc: 'Kandake will call you at a convenient time to discuss your needs and confirm your appointment.',
  },
]

export const trustSignals = [
  'All enquiries are confidential',
  'Kandake personally reviews every message',
  'No automated replies. Always personal',
  'Response within 24–48 hours',
]
